import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const ServiceContent = [
  {
    icon: "icon_31",
    title: "Data Analytics",
    routerPath: "/data-analytics",
    desc: `The data analytics process has some components that can help a variety of initiatives. `,
    // arrow: "icon_20",
    // datadelay: "",
    // dataAos: "fade-right",
    // className: "",
  },
  {
    icon: "icon_32",
    title: "Business Strategy",
    routerPath: "/business-strategy",
    desc: `A business strategy is a business document that describes a course of action to help leaders achieve organisational objectives. `,
    // arrow: "icon_20",
    // datadelay: "100",
    // dataAos: "fade-up",
    // className: "active",
  },
  {
    icon: "icon_33",
    title: "Technology Consulting",
    routerPath: "/Technology-Consulting",
    desc: `Once a business owner defined the needs to take a business to the next level, a decision maker will define a scope, cost and a time frame of the project.`,
    // arrow: "icon_20",
    // dataDelay: "",
    // dataAos: "fade-left",
    // className: "",
  },
  {
    icon: "icon_31",
    title: "Change Management",
    routerPath: "/change-management",
    desc: `Change management is the process of guiding organizational change to fruition, from the earliest stages of conception and preparation, through implementation and, finally, to resolution.`,
    // arrow: "icon_20",
    // datadelay: "",
    // dataAos: "fade-right",
    // className: "",
  },
  {
    icon: "icon_32",
    title: "Ed Tech",
    routerPath: "/ed-tech",
    desc: `Information Technology is a vital element in today’s schools.  Technology is a powerful tool for teaching and learning, and is essential in the effort to prepare students for success in the future.`,
    // arrow: "icon_20",
    // datadelay: "100",
    // dataAos: "fade-up",
    // className: "active",
  },
  {
    icon: "icon_33",
    title: "Application Services",
    routerPath: "/our-industries",
    desc: `The environment in which applications are deployed is always changing. Traffic can suddenly spike as a result of legitimate demand.
        
        `,
    // arrow: "icon_20",
    // dataDelay: "",
    // dataAos: "fade-left",
    // className: "",
  },
];
const FancyFeatureSeventeen = () => {
  return (
    <Fragment>
      <div className="row justify-content-center pt-30">
        {ServiceContent.map((val, i) => (
          <div
            key={i}
            className="col-lg-4 col-md-6"
            data-aos={val.dataAos}
            data-aos-delay={val.dataDelay}
          >
            <div
              className={`block-style-twelve block-space mt-30 ${val.className}`}
            >
              <div className="icon d-flex align-items-end">
                <img src={`images/icon/${val.icon}.svg`} alt="" />
              </div>
              <h5>
                <Link to={`${val.routerPath}`}>{val.title}</Link>
              </h5>
              <p>{val.desc}</p>
              {/* <Link to="/service-details" className="tran3s more-btn">
                <img src="images/icon/icon_20.svg" alt="" />
              </Link> */}
            </div>
            {/* /.block-style-twelve */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default FancyFeatureSeventeen;
